import { RewardsEarningRulesRewardEntity } from "@apps/rewards/modules/EarningRules/models/RewardsEarningRulesEntities";
import { RewardsVipTiersRewardEntity } from "@apps/rewards/modules/VipTiers/models/RewardsVipTiersEntities";

import { BaseRewardDTO } from "../../types";

export const mapBaseRewardToDTO = (
    rewarding: RewardsEarningRulesRewardEntity | RewardsVipTiersRewardEntity
): BaseRewardDTO => {
    switch (rewarding.type) {
        case "points": {
            if ("amountSpent" in rewarding) {
                return {
                    type: "points",
                    points: rewarding.points,
                    amountSpent: rewarding.amountSpent,
                };
            }
            return {
                type: "points",
                points: rewarding.points,
            };
        }
        case "discount":
            return {
                type: rewarding.type,
                discountValue: rewarding.discountValue,
            };
        case "gift_card":
            return {
                type: rewarding.type,
                initialValue: rewarding.initialValue,
            };
        case "free_product":
            return {
                type: rewarding.type,
                discountValue: rewarding.discountValue,
                productHandle: rewarding.productHandle,
                productTitle: rewarding.productTitle,
                productImage: rewarding.productImage,
                productId: rewarding.productId,
                variants: rewarding.variants,
            };
        default:
            throw new Error("Unknown type");
    }
};
